const SvgSecurity1 = (props) => (
  <>
    <path
      d="M96 40c-30.93 0-56 25.07-56 56s25.07 56 56 56 56-25.07 56-56-25.07-56-56-56Zm.01 72h-.04c-8.82 0-15.98-7.16-15.98-16s7.15-16 15.98-16h.04c8.82 0 15.98 7.16 15.98 16s-7.15 16-15.98 16Z"
      fill={props.p20}
      stroke={props.p30}
      strokeMiterlimit={10}
    />
    <path
      d="M96 0C42.98 0 0 42.98 0 96s42.98 96 96 96 96-42.98 96-96S149.02 0 96 0Z"
      fill="none"
      stroke={props.p30}
      strokeMiterlimit={10}
    />
    <circle cx={96} cy={40} r={4} fill={props.p30} />
    <circle cx={96} r={4} fill={props.p30} />
    <circle cx={96} cy={192} r={4} fill={props.p30} />
    <circle cx={96} cy={152} r={4} fill={props.p30} />
    <circle cy={96} r={4} fill={props.p30} />
    <circle cx={40} cy={96} r={4} fill={props.p30} />
    <circle cx={152} cy={96} r={4} fill={props.p30} />
    <circle cx={192} cy={96} r={4} fill={props.p30} />
  </>
);

export default SvgSecurity1;
